import { periodicCostElementService } from 'features/cost-analysis/costs/api/periodic-cost-element.service';
import { movementReasonService } from 'features/inventory/movements/api/movement-reason.service';
import { movementService } from 'features/inventory/movements/api/movement.service';
import { orderService } from 'features/inventory/purchase-orders/api/order.service';
import { supplierService } from 'features/inventory/suppliers/api/SupplierService';
import { ticketingService } from 'features/inventory/ticketing/TicketingService';
import { transportDocumentService } from 'features/inventory/transport-documents/TransportDocument/api/transport-document.service';
import { productWarehouseService } from 'features/inventory/warehouses/api/product-warehouse.service';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';
import { sectorService } from 'features/settings/topology/api/sector.service';
import {
  productService,
  categoryService,
  invoiceService,
  equipmentInvoiceService,
  contractService,
  locationService,
  equipmentService,
  typeService,
  costElementService,
  additionalEquipmentCostService,
  regionalRateService,
  workstationService,
  examService,
  laboratoryService
} from 'shared/services';
import { BaseService } from 'shared/services/BaseService';
import { operationalUnitService } from 'features/settings/topology/api/operational-unit.service';

export type HistoryModelFieldConfig = {
  name: string;
  code: string;
  service: BaseService<any>;
  getMethod?: string;
  optionLabelField?: string;
  optionValueField?: string;
};

export type HistoryModelConfig = {
  label: string;
  fields?: HistoryModelFieldConfig[];
  service?: BaseService<any>;
  getMethod?: string;
  optionLabelField?: string;
  optionValueField?: string;
};

export const MODELS_MAPS: Record<string, HistoryModelConfig> = {
  product: { label: 'Articolo', service: productService, optionValueField: 'code' },
  category: { label: 'Categoria', service: categoryService },
  transportdocument: {
    label: 'Consegna',
    service: transportDocumentService,
    optionLabelField: 'ref',
    optionValueField: 'ref'
  },
  invoice: {
    label: 'Fattura',
    service: invoiceService,
    getMethod: 'getAllPaginated',
    optionLabelField: 'ref',
    optionValueField: 'ref'
  },
  equipmentinvoice: {
    label: 'Fatturazione strumento',
    service: equipmentInvoiceService,
    getMethod: 'getAllPaginated',
    optionLabelField: 'ref',
    optionValueField: 'ref'
  },
  movement: { label: 'Movimento', service: movementService, getMethod: 'getAllPaginated' },
  movementtype: { label: 'Causale', service: movementReasonService, getMethod: 'getAllPaginated' },
  warehouse: { label: 'Magazzino', service: warehouseService, optionLabelField: 'code' },
  contract: { label: 'Contratto', service: contractService, optionLabelField: 'code' },
  location: { label: 'Piazza', service: locationService },
  contractline: {
    label: 'Linea contratto',
    fields: [
      { name: 'Articolo', code: 'product', service: productService },
      {
        name: 'Contratto',
        code: 'contract_header',
        service: contractService,
        optionLabelField: 'code'
      }
    ]
  },
  contractequipment: {
    label: 'Contratto strumento',
    fields: [
      { name: 'Strumento', code: 'equipment', service: equipmentService },
      {
        name: 'Contratto',
        code: 'contract_header',
        service: contractService,
        optionLabelField: 'code'
      }
    ]
  },
  operationalunit: { label: 'Unità operativa', service: operationalUnitService },
  equipment: {
    label: 'Strumento',
    service: equipmentService,
    optionLabelField: 'code',
    optionValueField: 'code'
  },
  sector: { label: 'Settore', service: sectorService },
  supplier: { label: 'Fornitore', service: supplierService },
  type: { label: 'Tipo', service: typeService },
  periodiccostelement: {
    label: 'Costo Periodico',
    service: periodicCostElementService,
    getMethod: 'getAllPaginated'
  },
  costelement: {
    label: 'Costo Elemento',
    service: costElementService,
    getMethod: 'getAllPaginated'
  },
  additionalequipmentcost: {
    label: 'Costo Servizio Extra',
    service: additionalEquipmentCostService,
    getMethod: 'getAllPaginated',
    optionLabelField: 'code'
  },
  regionalrate: { label: 'Tariffa Regionale', service: regionalRateService },
  technicalassistenceticket: {
    label: 'Ticket Assistenza Tecnica',
    service: ticketingService,
    optionLabelField: 'id',
    getMethod: 'getAllPaginated'
  },
  workstation: { label: 'Stazione di lavoro', service: workstationService },
  exam: { label: 'Esame', service: examService },
  laboratory: { label: 'Laboratorio', service: laboratoryService },
  productwarehouse: {
    label: 'Soglia',
    fields: [
      { name: 'Articolo', code: 'product', service: productService },
      { name: 'Magazzino', code: 'warehouse', service: warehouseService }
    ],
    service: productWarehouseService
  },
  purchaseorderhead: {
    label: 'Ordine',
    service: orderService,
    getMethod: 'getAllPaginated',
    optionLabelField: 'ref',
    optionValueField: 'ref'
  },
  purchaseorderline: {
    label: 'Linea ordine',
    fields: [
      {
        name: 'Ordine',
        code: 'ref_id',
        service: orderService,
        getMethod: 'getAllPaginated',
        optionLabelField: 'ref',
        optionValueField: 'ref'
      },
      { name: 'Articolo', code: 'product', service: productService }
    ]
  }
};

export const getModelLabel = (modelName?: string) =>
  (modelName ? MODELS_MAPS[modelName]?.label : null) ?? modelName ?? '';
